module.exports = __webpack_public_path__ + "static/media/android_tips_01.6966c0fd.png";